import { LLMModel } from './Enum';

export interface ChatMessage {
  role: 'user' | 'assistant';
  content: string;
}

export const LLM_MODEL_TABLE = {
  [LLMModel.Claude_Sonnet_4_0]: 'claude-sonnet-4-20250514',
  [LLMModel.GPT_5]: 'gpt-5-2025-08-07',
  [LLMModel.Gemini_2_5]: 'gemini-2.5-flash-image', // "gemini-2.5-pro", "gemini-2.5-flash", "gemini-2.5-flash-lite",
  // [LLMModel.GPT_OpenAI_o3]: 'o3-2025-04-16',
};

// export const LLM_MODEL_ENUM = {
//   [LLMModel.Claude_Sonnet_4_0]: 'sonnet-4',
//   [LLMModel.GPT_5]: 'gpt-5',
//   [LLMModel.Gemini_2_5]: 'gemini-2.5',
// };
